import angular from 'angular';
import RenderDynamicLinkCtrl from './renderDynamicLinkCtrl';

export default angular
  .module('components.renderDynamicLink', [])
  .component('renderDynamicLink', {
    controller: RenderDynamicLinkCtrl,
    controllerAs: 'vm',
  }).name;
